"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundEventHandlerScript = void 0;
class BoundEventHandlerScript {
    constructor(key, args) {
        this.key = key;
        this.args = args;
    }
}
exports.BoundEventHandlerScript = BoundEventHandlerScript;
